import { render, staticRenderFns } from "./SwiperVirtual.vue?vue&type=template&id=409b18ce&"
import script from "./SwiperVirtual.vue?vue&type=script&lang=js&"
export * from "./SwiperVirtual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports